import { apiPost } from '../client';
import { LONG_TIMEOUT_MS } from '../../config/env';
import type {
  BookingRequest,
  FinalizeShoppingResponse,
  LocationSearchRequest,
  LocationSearchResponse,
  PaymentRequest,
  PaymentResponse,
  PrebookingRequest,
  PrebookingResponse,
  TransferAllocateRequest,
  TransferCartResponse,
  TransferSearchRequest,
  TransferSearchResponse,
  UpdatePassengersRequest,
  UpdatePassengersResponse,
} from '../types/transfer';

export function searchTransferLocations(location: string): Promise<LocationSearchResponse> {
  return apiPost<LocationSearchRequest, LocationSearchResponse>('Transfer/Location/Search', { location });
}

export function searchTransfers(body: TransferSearchRequest): Promise<TransferSearchResponse> {
  return apiPost<TransferSearchRequest, TransferSearchResponse>('Transfer/Search', body);
}

export function allocateTransfer(body: TransferAllocateRequest): Promise<TransferCartResponse> {
  return apiPost<TransferAllocateRequest, TransferCartResponse>('Transfer/Allocate', body);
}

export function updateTransferPassengers(body: UpdatePassengersRequest): Promise<UpdatePassengersResponse> {
  return apiPost<UpdatePassengersRequest, UpdatePassengersResponse>('Transfer/UpdatePassengers', body);
}

export function makeTransferPrebooking(body: PrebookingRequest): Promise<PrebookingResponse> {
  return apiPost<PrebookingRequest, PrebookingResponse>('Transfer/MakePrebooking', body);
}

export function finalizeTransferShopping(body: BookingRequest): Promise<FinalizeShoppingResponse> {
  return apiPost<BookingRequest, FinalizeShoppingResponse>('Transfer/FinalizeShopping', body, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}

/** Shared route (not Transfer-prefixed) — used by every product module's payment step. */
export function makeTransferPayment(body: PaymentRequest): Promise<PaymentResponse> {
  return apiPost<PaymentRequest, PaymentResponse>('MakePayment', body, { timeoutMs: LONG_TIMEOUT_MS });
}
